import { render, staticRenderFns } from "./ExecutiveDirectorManagement.vue?vue&type=template&id=b8ec5fc0&scoped=true"
import script from "./ExecutiveDirectorManagement.vue?vue&type=script&lang=js"
export * from "./ExecutiveDirectorManagement.vue?vue&type=script&lang=js"
import style0 from "./ExecutiveDirectorManagement.vue?vue&type=style&index=0&id=b8ec5fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ec5fc0",
  null
  
)

export default component.exports